import { useMutation } from '@tanstack/react-query'

import { generateFreeeRedirectUrl } from '@src/api'
import { DefaultApiGenerateFreeeRedirectUrlRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useGenerateFreeeRedirectUrl = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiGenerateFreeeRedirectUrlRequest) =>
      generateFreeeRedirectUrl(axiosInstance, params),
  })
}
